export const SAC_TYPE = {
  PostComment: { value: 'PostComment' },
  MentionComment: { value: 'MentionComment' },
  ExternalComment: { value: 'ExternalComment' },
  ReviewComment: { value: 'ReviewComment' },
  VisitorComment: { value: 'VisitorComment' },
  Mention: { value: 'Mention' },
  Review: { value: 'Review' },
  Post: { value: 'Post' },
  VisitorPost: { value: 'VisitorPost' },
  Inbox: { value: 'Inbox' },
  Story: { value: 'Story' },
  Reels: { value: 'Reels' },
};

export default {
  data() {
    return {
      channelSacTypes: {
        facebook: [
          SAC_TYPE.Post.value,
          SAC_TYPE.PostComment.value,
          SAC_TYPE.Mention.value,
          SAC_TYPE.MentionComment.value,
          SAC_TYPE.Inbox.value,
          SAC_TYPE.VisitorPost.value,
          SAC_TYPE.VisitorComment.value,
          SAC_TYPE.Review.value,
          SAC_TYPE.ReviewComment.value,
        ],
        instagram: [
          SAC_TYPE.Post.value,
          SAC_TYPE.Mention.value,
          SAC_TYPE.PostComment.value,
          SAC_TYPE.MentionComment.value,
          SAC_TYPE.ExternalComment.value,
          SAC_TYPE.Story.value,
          SAC_TYPE.Inbox.value,
          SAC_TYPE.Reels.value,
        ],
        twitter: [
          SAC_TYPE.Post.value,
          SAC_TYPE.Inbox.value,
          SAC_TYPE.Mention.value,
          SAC_TYPE.PostComment.value,
          SAC_TYPE.MentionComment.value,
        ],
        youtube: [
          SAC_TYPE.Post.value,
          SAC_TYPE.PostComment.value,
        ],
        linkedin: [
          SAC_TYPE.Post.value,
          SAC_TYPE.PostComment.value,
          SAC_TYPE.Mention.value,
          SAC_TYPE.MentionComment.value,
        ],
        TikTok: [
          SAC_TYPE.Post.value,
          SAC_TYPE.PostComment.value,
          SAC_TYPE.ExternalComment.value,
          SAC_TYPE.Mention.value,
          SAC_TYPE.Inbox.value,
        ],
      },
    };
  },
  computed: {
    typesObj() {
      return {
        PostComment: { name: this.$t('mixins.sacTypeModel.PostComment'), value: 'PostComment' },
        MentionComment: { name: this.$t('mixins.sacTypeModel.MentionComment'), value: 'MentionComment' },
        ExternalComment: { name: this.$t('mixins.sacTypeModel.ExternalComment'), value: 'ExternalComment' },
        ReviewComment: { name: this.$t('mixins.sacTypeModel.ReviewComment'), value: 'ReviewComment' },
        VisitorComment: { name: this.$t('mixins.sacTypeModel.VisitorComment'), value: 'VisitorComment' },
        Mention: { name: this.$t('mixins.sacTypeModel.Mention'), value: 'Mention' },
        Review: { name: this.$t('mixins.sacTypeModel.Review'), value: 'Review' },
        Post: { name: this.$t('mixins.sacTypeModel.Post'), value: 'Post' },
        VisitorPost: { name: this.$t('mixins.sacTypeModel.VisitorPost'), value: 'VisitorPost' },
        Inbox: { name: this.$t('mixins.sacTypeModel.Inbox'), value: 'Inbox' },
        Story: { name: this.$t('mixins.sacTypeModel.Story'), value: 'Story' },
        Reels: { name: this.$t('mixins.sacTypeModel.Reels'), value: 'Reels' },
      };
    },
    sacTypeList() {
      return {
        PostComment: this.$t('mixins.sacTypeModel.PostComment'),
        MentionComment: this.$t('mixins.sacTypeModel.MentionComment'),
        ExternalComment: this.$t('mixins.sacTypeModel.ExternalComment'),
        ReviewComment: this.$t('mixins.sacTypeModel.ReviewComment'),
        VisitorComment: this.$t('mixins.sacTypeModel.VisitorComment'),
        Mention: this.$t('mixins.sacTypeModel.Mention'),
        Review: this.$t('mixins.sacTypeModel.Review'),
        Post: this.$t('mixins.sacTypeModel.Post'),
        VisitorPost: this.$t('mixins.sacTypeModel.VisitorPost'),
        Inbox: this.$t('mixins.sacTypeModel.Inbox'),
        Story: this.$t('mixins.sacTypeModel.Story'),
        Reels: this.$t('mixins.sacTypeModel.Reels'),
      };
    },
    SAC_TYPE_MAP() {
      return this.sacTypeList;
    },
  },
  methods: {
    getTypesByChannels(channels = []) {
      const allTypes = channels.reduce((types, channel) => {
        const channelTypes = this.channelSacTypes[channel] || [];
        return [...types, ...channelTypes];
      }, []);
      return Array.from(new Set(allTypes));
    },
  },
};
